export default __webpack_public_path__ + "static/media/12 1.3ff3d368.svg";